module.exports = __webpack_public_path__ + "sourcesanspro.c4f39c8cef7f1746da98.woff";


//////////////////
// WEBPACK FOOTER
// /Users/tabelini/development/jvm/tenacity/pysix/PysixCloud/src/fonts/sourcesanspro/sourcesanspro.woff
// module id = ../../../../../src/fonts/sourcesanspro/sourcesanspro.woff
// module chunks = styles